import { Component, Input, Output, EventEmitter } from '@angular/core';

import { SEARCH_CONFIG_MINI_PROJECT } from 'app/fs/res/common/model/searchConstants';
import { ResearchContract } from 'app/fs/res/common/model/finance/research-contract-classes';
import { Project } from 'app/fs/res/finance/model/project/project';

@Component( {
    selector: 'res-funding-program-panel',
    templateUrl: './funding-program-panel.component.html',
} )

export class FundingProgramPanelComponent {
    @Input() editMode = true;
    @Input() set projects(value: Project[]) {
        this.setProjectFundingPrograms(value);
    }
    @Input() fundingPrograms: ResearchContract[];
    @Output() fundingProgramsChange = new EventEmitter<ResearchContract[]>();
    public projectFundingPrograms: ResearchContract[] = [];
    public pseudonymizedResearchPartners: string[] = [];
    public displayAddFundingProgramDialog = false;

    public editIndex: number;

    readonly SEARCH_CONFIG_MINI_PROJECT = SEARCH_CONFIG_MINI_PROJECT;
    public dateFormat: string;

    private setProjectFundingPrograms(projects: Project[]) {
        this.pseudonymizedResearchPartners = [];
        let projectStatusHiskeyIdsFiltered = [102, 103, 1001];
        let bsTypeThirdParty = 17;
        let projectFundingPrograms: ResearchContract[]  = [];
        if (projects) {
            projects.filter(p => projectStatusHiskeyIdsFiltered.indexOf(p.projectStatus.hiskeyId) > -1)
                .forEach(p => {
                    if (p.fundingPrograms) {
                        projectFundingPrograms = projectFundingPrograms.concat(p.fundingPrograms);
                    }
                });

            this.projectFundingPrograms = projectFundingPrograms
                .filter(fP => !fP.budgetSource || fP.budgetSource?.budgetSourceType?.hiskeyId === bsTypeThirdParty);
        } else {
            this.projectFundingPrograms = null;
        }
    }

    public getSortedFundingPrograms() {
        return this.sort(this.fundingPrograms, 'funderName');
    }

    private sort( objectList: any[], sortAttribute: string ){
        return objectList.sort( (a, b) =>
        {
            if (a[sortAttribute].toLowerCase() < b[sortAttribute].toLowerCase()) { return -1; }
            if (a[sortAttribute].toLowerCase() > b[sortAttribute].toLowerCase()) { return 1; }
            return 0;
        });
    }

    public onAddNewFundingProgram() {
        if(this.fundingPrograms == null){
            this.fundingPrograms = [];
        }
        this.editIndex = null;
        this.displayAddFundingProgramDialog = true;
    }

    public onFundingProgramChange( fundingProgram: ResearchContract ) {
        if ( !this.fundingPrograms ) {
            this.fundingPrograms = [];
        }
        // if fundingProgram was in list before
        if ( this.editIndex != null ){
            this.fundingPrograms.splice(this.editIndex, 1);
        }
        this.fundingPrograms.push(fundingProgram);
        this.fundingProgramsChange.emit(this.fundingPrograms);
    }

    // public editFundingProgram( fundingProgram: ResearchContract ) {
    public editFundingProgram( index: number) {
        this.editIndex = index;
        this.displayAddFundingProgramDialog = true;
    }

    public removeFundingProgram( fundingProgram: ResearchContract ) {
        const index = this.fundingPrograms.indexOf( fundingProgram );
        this.fundingPrograms.splice( index, 1 );
        this.fundingProgramsChange.emit(this.fundingPrograms);
    }
}
